import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../services/index";

// รายการกลุ่ม Telegram ที่ผูกกับบริษัทปัจจุบัน
export const useFetchTelegramGroups = (companyId) => {
  return useQuery(
    ["telegramGroups", companyId],
    async () => {
      const { result } = await GET(`/api/v1/telegramBot/groups`);
      return result || [];
    },
    { enabled: !!companyId }
  );
};

export const useCreateTelegramGroup = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/telegramBot/groups`, payload),
  });
};

export const useUpdateTelegramGroup = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) => await PUT(`/api/v1/telegramBot/groups/${id}`, payload),
  });
};

export const useDeleteTelegramGroup = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/telegramBot/groups/${id}`),
  });
};
